import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import {EventStore} from "../server/EventStore.ts";

Html.registerWidget('widget/minievent',{initDom,destroyDom})

var node: HTMLElement;
async function display(){
  var calendarIds = (await EventStore.getSelectedCalendarIds()).filter(id=>!id.startsWith("calendarTask/"))
  const events = await EventStore.loadEventsBySync(calendarIds,[],{start:new Date(),end:new Date(new Date().getTime()+3600000*24*60)});
  events.sort((a,b)=>a.start-b.start)
  const TPL = await import("../widget/minievent.mustache");
  Html.setHtml(node,TPL,{feed:events.slice(0,4)});
}

function initDom(container: HTMLElement){
  node = container;
  if(container.offsetParent !== null) { // Vérifie si l'élément est visible
    display();
    amplify.subscribe("eventCreated eventUpdated eventDeleted",display);
  }
}
function destroyDom(){
  amplify.unsubscribe("eventCreated eventUpdated eventDeleted",display);
}
